import React from 'react';

export const compose = (...elements: React.ReactElement<any, any>[]) =>
  elements.reduceRight((child, parent) =>
    React.cloneElement(parent, {}, child),
  );
